// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#welcome[data-v-a3860f62]{position:relative;height:84vh}#welcome>div[data-v-a3860f62]{background-size:cover;background-position:50%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
